import type { FormRequest } from "@/app/_services/contactService";

export const STATUS_LABELS: Record<FormRequest["status"], string> = {
  new: "New",
  accepted: "Accepted",
  declined: "Declined",
};

export const FORM_TYPE_LABELS: Record<FormRequest["form_type"], string> = {
  contact_us: "Contact us",
  work_with_us: "Work with us",
};
